const hasTags = (s) => /<[a-z][\s\S]*>/i.test(s || "");

export const RichText = ({ html, className = "" }) => {
  const content = hasTags(html) ? html : `<p>${html || ""}</p>`;
  return <div className={`bsd-prose ${className}`} dangerouslySetInnerHTML={{ __html: content }} />;
};
